export default __webpack_public_path__ + "static/media/team-leader-milestone-tracker-header.8ce04f6c.png";